// Guide/GuidesPage.tsx

import React, {useContext, useEffect, useState} from 'react';
import {useErrorProcessing} from 'Core/components/ErrorProvider';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import CircularProgress from 'Core/components/elements/CircularProgress';
import {FRCT} from 'WideLayout/Layouts';
import {AuthContext, AuthContextType} from 'Auth/AuthContext';
import pprint from '../../Utils/pprint';
import GuideCard from "Guide/GuideCard";
import Head from "Core/components/Head";
import {IGuide} from "Types/psychology/guide";

interface GuidesPageProps {
    cls?: string;
}

const GuidesPage: React.FC<GuidesPageProps> = (
    {
        cls,
    }) => {
    const [guides, setGuides] = useState<IGuide[]>([]);
    const [userGuides, setUserGuides] = useState<IGuide[]>([]);
    const {byResponse} = useErrorProcessing();
    const {isAuthenticated} = useContext(AuthContext) as AuthContextType;

    useEffect(() => {
        const fetchGuides = async () => {
            try {
                const response = await axios.get('/api/v1/guides/');
                pprint('Guides');
                pprint(response.data);
                setGuides(response.data);
            } catch (error) {
                byResponse(error);
            }
        };
        const fetchUserGuides = async () => {
            try {
                const response = await axios.get('/api/v1/user/guides/');
                pprint('User Guides');
                pprint(response.data);
                setUserGuides(response.data);
            } catch (error) {
                byResponse(error);
            }
        };
        fetchGuides().then();
        if (isAuthenticated) fetchUserGuides().then();
    }, [isAuthenticated]);

    if (!guides.length) return <CircularProgress size={'150px'}/>;

    const userGuideIds = new Set(userGuides.map((guide) => guide.id));
    const filteredGuides = guides.filter((guide) => !userGuideIds.has(guide.id));
    const publicGuides = filteredGuides.filter((guide) => guide.is_public);
    const privateGuides = filteredGuides.filter((guide) => !guide.is_public);
    const allGuides = [...userGuides, ...publicGuides, ...privateGuides];

    return (
        <><Head
            title={'Гайды | Лайф Хелп'}
            description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
            robots={'noindex, nofollow'}
            canonicalUrl={`${DOMAIN_URL}/guides`}/>
            <FRCT cls={cls} maxW={800} p={2} wrap g={2} scroll={'y-auto'}>
                {allGuides.map((guide) => (
                    <GuideCard key={guide.id} guide={guide}/>
                ))}
            </FRCT></>
    );
};

export default GuidesPage;
